import React, { createContext, useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";

const NiUiContext = createContext();

export const useNiUi = () => useContext(NiUiContext);

export const NiUiProvider = ({ children, initialConfig = {} }) => {
  const [config, setConfig] = useState(initialConfig); // Use initialConfig to set initial state for things like socials etc
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [scrollDepth, setScrollDepth] = useState(0);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <NiUiContext.Provider
      value={{
        config,
        setConfig,
        hamburgerOpen,
        setHamburgerOpen,
        scrollDepth,
        setScrollDepth,
        theme,
        setTheme
      }}
    >
      <div className={styles.provider} data-theme={theme}>
        {children}
      </div>
    </NiUiContext.Provider>
  );
};
